import { gql } from '@apollo/client';

export const GET_DEPENDENTS = gql`
  query GetDependentsQuery {
    getDependents {
      id
      firstName
      lastName
      active
      dateOfBirth
      clExperience
    }
  }
`;
